module.exports = __webpack_public_path__ + "static/media/sketch-panam-1250.24596af0.png";